export class BudgetModel {
  constructor() {
    this.id = null;
    this.campaignStartDate = null;
    this.applicationStartDate = null;
    this.applicationEndDate = null;
    this.verificationStartDate = null;
    this.verificationEndDate = null;
    this.applicationAnnouncementDate = null;
    this.votingStartDate = null;
    this.votingEndDate = null;
    this.votingResultDate = null;
    this.applicationTemplate = {
      reasonRequired: false,
      locationAddressRequired: false,
      locationCityRequired: false,
      locationDescriptionRequired: false,
      locationPlotNumberRequired: false,
      descriptions: [],
      details: [],
      voterRequiredData: {
        fullName: false,
        gender: false,
        pesel: false,
        address: false,
        age: false,
        status: false,
        email: false,
        phoneNumber: false,
        organization: false,
      },
      voterRequiredDataDescription: null,
    };
    this.type = null;
    this.values = null;
    this.points = null;
    this.parcelsAutocompletionEnabled = false;
    this.isActive = false;
  }
}



// WEBPACK FOOTER //
// ./src/models/BudgetModel.js